export const CURRENCY = 'EUR';
export const CURRENCY_SYMBOL = '€';
export const MIN_LOAN_AMOUNT = 2000;
export const MAX_LOAN_AMOUNT = 10000;
export const MIN_NUMBER_OF_INSTALMENTS = 12;
export const MAX_NUMBER_OF_INSTALMENTS = 84;
export const LOAN_AMOUNT_INPUT_ID = 'loan-amount';
export const SELECTED_LOAN_CONDITION_STORAGE_KEY = 'creditis-loan-condition';
export const AMOUNT_VALUE_STORAGE_KEY = 'creditis-amount-value';
